module.exports = __webpack_public_path__ + "img/contact.55648324.jpg";